import * as Yup from 'yup';

const createRawMaterialSchema = Yup.object().shape({
  title: Yup.string().label('Raw material material').default('').required('This field is required'),
}) as Yup.ObjectSchema;

export default createRawMaterialSchema;
